/* eslint-disable */

export enum AccountType {
  CHECKING = "CHECKING",
  SAVINGS = "SAVINGS",
  SPONSORED_CHECKING = "SPONSORED_CHECKING",
  SPONSORED_SAVINGS = "SPONSORED_SAVINGS",
}

export interface Account {
  customer_token?: string;
  account_type?: AccountType;
  account_token?: string;
  is_sponsored_account?: boolean;
  display_name?: string;
}
